"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBodyText = exports.StyledTextBlock = exports.StyledHeader = exports.TextContainer = exports.StyledIconButton = exports.StyledIcon = exports.ListItemContainer = exports.ListItem = exports.CrudButton = exports.ButtonText = exports.ButtonContainer = exports.RowInfoContainer = exports.PrimaryIndicatorContainer = exports.ItemNumberText = exports.ItemNumberContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _IconButton = _interopRequireDefault(require("../../Buttons/IconButton"));

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

var _helperFunctions = require("../../../styles/helperFunctions");

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calculateSlideWidthAdjustmentREMs = function calculateSlideWidthAdjustmentREMs(props) {
  return (0, _helperFunctions.joinDimensions)('*', props.crudButtonCount / 2, props.theme.crudButtonWidth);
};

var assignBackgroundColor = function assignBackgroundColor(props, color) {
  if (color.charAt(0) === '#' || color.substr(0, 3).toLowerCase === 'rgb') {
    return color;
  }

  if (!props.theme[color]) {
    throw new Error("No constant found for ".concat(color, " in the current theme"));
  }

  return props.theme[color];
}; // Styles


var RowInfoItem = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__RowInfoItem",
  componentId: "sc-1ah8ut8-0"
})(["position:absolute;top:0;left:0;right:0;min-height:100%;max-height:100%;display:flex;flex-direction:row;justify-content:center;align-content:center;align-items:center;"]);

var ItemNumberContainer = (0, _styledComponents.default)(RowInfoItem).withConfig({
  displayName: "CrudListItemstyles__ItemNumberContainer",
  componentId: "sc-1ah8ut8-1"
})(["z-index:", ";"], function (props) {
  return props.theme.dropDown;
});
exports.ItemNumberContainer = ItemNumberContainer;
var ItemNumberText = (0, _styledComponents.default)(_PrimaryText.default).withConfig({
  displayName: "CrudListItemstyles__ItemNumberText",
  componentId: "sc-1ah8ut8-2"
})(["color:", ";font-weight:", ";overflow:hidden;margin-top:.2rem;text-overflow:ellipsis;white-space:nowrap;"], function (props) {
  return props.isPrimary ? props.theme.c_foreground_overDark : props.theme.c_foreground_default;
}, function (props) {
  return props.theme.primaryMedium;
});
exports.ItemNumberText = ItemNumberText;
var PrimaryIndicatorContainer = (0, _styledComponents.default)(RowInfoItem).withConfig({
  displayName: "CrudListItemstyles__PrimaryIndicatorContainer",
  componentId: "sc-1ah8ut8-3"
})([""]);
exports.PrimaryIndicatorContainer = PrimaryIndicatorContainer;

var RowInfoContainer = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__RowInfoContainer",
  componentId: "sc-1ah8ut8-4"
})(["position:relative;min-width:", ";max-width:", ";height:", ";max-height:", ";"], function (props) {
  return props.theme.infoCellWidth;
}, function (props) {
  return props.theme.infoCellWidth;
}, function (props) {
  return props.theme.topThirdHeightOffset;
}, function (props) {
  return props.theme.topThirdHeightOffset;
});

exports.RowInfoContainer = RowInfoContainer;

var ButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__ButtonContainer",
  componentId: "sc-1ah8ut8-5"
})(["display:flex;flex-direction:row;justify-content:center;min-height:100%;"]);

exports.ButtonContainer = ButtonContainer;

var ButtonText = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__ButtonText",
  componentId: "sc-1ah8ut8-6"
})(["margin-top:", ";color:", ";"], function (props) {
  return props.theme.infoPadding;
}, function (props) {
  return props.theme.c_foreground_overDark;
});

exports.ButtonText = ButtonText;

var CrudButton = _styledComponents.default.button.withConfig({
  displayName: "CrudListItemstyles__CrudButton",
  componentId: "sc-1ah8ut8-7"
})(["box-shadow:0 0 0 1px ", ";outline:none;min-height:100%;background-color:", ";min-width:", ";cursor:pointer;display:flex;flex-direction:column;justify-content:center;align-items:center;align-content:center;:active,:hover{background-color:", ";}:disabled{cursor:default;background-color:", ";}"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return assignBackgroundColor(props, props.buttonColor);
}, function (props) {
  return props.theme.crudButtonWidth;
}, function (props) {
  return assignBackgroundColor(props, props.activeButtonColor);
}, function (props) {
  return props.theme.c_clickable_disabled_background;
});

exports.CrudButton = CrudButton;

var ListItem = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__ListItem",
  componentId: "sc-1ah8ut8-8"
})(["position:relative;", ";height:100%;min-height:", ";display:flex;flex-direction:row;align-content:center;transition:all ", " ease-in-out;*{transition:all ", " ease-in-out,background-color 1ms  linear;}"], function (props) {
  return props.active ? "left: -".concat(calculateSlideWidthAdjustmentREMs(props)) : 'left: 0';
}, function (props) {
  return props.theme.cardMinimumHeight;
}, function (props) {
  return props.theme.noWaitAnimationDuration;
}, function (props) {
  return props.theme.noWaitAnimationDuration;
});

exports.ListItem = ListItem;

var ListItemContainer = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__ListItemContainer",
  componentId: "sc-1ah8ut8-9"
})(["width:", ";min-height:", ";overflow:hidden;margin:", ";border-top:", " solid ", ";&:last-child{border-bottom:", " solid ", ";}"], function (props) {
  return props._inStyleGuide ? props.theme.componentSizeLarge : '100%';
}, function (props) {
  return props.theme.cardMinimumHeight;
}, function (props) {
  return props._inStyleGuide ? props.theme.fullsizeComponentOffset : '0';
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_foreground_gridLines;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_foreground_gridLines;
});

exports.ListItemContainer = ListItemContainer;
var StyledIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "CrudListItemstyles__StyledIcon",
  componentId: "sc-1ah8ut8-10"
})(["color:", ";"], function (props) {
  return props.theme.c_foreground_overDark;
});
exports.StyledIcon = StyledIcon;
var StyledIconButton = (0, _styledComponents.default)(_IconButton.default).withConfig({
  displayName: "CrudListItemstyles__StyledIconButton",
  componentId: "sc-1ah8ut8-11"
})(["flex:1 1 15%;min-width:", ";margin-right:", ";"], function (props) {
  return props.theme.infoCellWidth;
}, function (props) {
  return props.active ? props.theme.activeToggleOffset : '0';
});
exports.StyledIconButton = StyledIconButton;

var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__TextContainer",
  componentId: "sc-1ah8ut8-12"
})(["width:", ";min-width:", ";max-width:", ";overflow:hidden;cursor:", ";padding:0 ", ";display:flex;flex-direction:row;justify-content:stretch;"], function (props) {
  return props.active ? "calc(100% - ".concat(calculateSlideWidthAdjustmentREMs(props), ")") : '100%';
}, function (props) {
  return props.active ? "calc(100% - ".concat(calculateSlideWidthAdjustmentREMs(props), ")") : '100%';
}, function (props) {
  return props.active ? "calc(100% - ".concat(calculateSlideWidthAdjustmentREMs(props), ")") : '100%';
}, function (props) {
  return props.active ? 'pointer' : 'default';
}, function (props) {
  return props.theme.standardPadding;
});

exports.TextContainer = TextContainer;
var StyledHeader = (0, _styledComponents.default)(_PrimaryText.default).withConfig({
  displayName: "CrudListItemstyles__StyledHeader",
  componentId: "sc-1ah8ut8-13"
})(["padding:0;margin:0;font-weight:", ";color:", ";text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"], function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.c_foreground_default;
});
exports.StyledHeader = StyledHeader;

var StyledTextBlock = _styledComponents.default.div.withConfig({
  displayName: "CrudListItemstyles__StyledTextBlock",
  componentId: "sc-1ah8ut8-14"
})(["width:100%;max-width:100%;display:flex;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;flex-flow:column nowrap;justify-content:center;padding:", ";"], function (props) {
  return props.theme.standardPadding;
});

exports.StyledTextBlock = StyledTextBlock;
var StyledBodyText = (0, _styledComponents.default)(_ParagraphText.default).withConfig({
  displayName: "CrudListItemstyles__StyledBodyText",
  componentId: "sc-1ah8ut8-15"
})(["max-width:100%;padding:0;margin:0;padding-top:", ";color:", ";text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"], function (props) {
  return props.theme.cardTextPadding;
}, function (props) {
  return props.theme.c_foreground_default;
});
exports.StyledBodyText = StyledBodyText;